import type { ReactNode } from "react";
import { Link } from "react-router";
import { withLastSearch } from "@/lib/listSearch";
import { Icon } from "../Icon/Icon";
import styles from "./Breadcrumbs.module.css";

export interface BreadcrumbItem {
  label: ReactNode;
  /** Omit for the current page (rendered as text with aria-current). A page without a search of its own
   * is linked with the filters it was last shown with. */
  to?: string;
}

/** Where a detail page sits: Materials › Hedione. */
export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="Breadcrumb" className={styles.nav}>
      <ol className={styles.list}>
        {items.map((item, index) => {
          const current = index === items.length - 1;
          return (
            <li key={index} className={styles.item}>
              {item.to && !current ? (
                <Link to={withLastSearch(item.to)} className={styles.link}>
                  {item.label}
                </Link>
              ) : (
                <span aria-current={current ? "page" : undefined} className={styles.current}>
                  {item.label}
                </span>
              )}
              {!current ? (
                <span className={styles.separator}>
                  <Icon name="chevronRight" />
                </span>
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
